import React from 'react';
import clsx from 'clsx';

import { Copy } from '../../components';

type CampaignNameProps = {
  id: string;
  name: string;

  inline?: boolean;
  className?: string;
};

const CampaignName: React.FC<CampaignNameProps> = ({
  id,
  name,
  className,
  inline = false,
}) => {
  return (
    <div
      className={clsx(
        className,
        inline ? 'flex flex-row gap-x-md items-center' : ''
      )}
    >
      {name}
      <div className={!inline ? 'mt-xs' : ''}>
        <span className="text-tiny text-textLight">{id}</span>
        <Copy
          text={id}
          label={false}
          className="ml-sm"
          message="Campaign ID copied successfully!"
        />
      </div>
    </div>
  );
};

export default React.memo(CampaignName) as typeof CampaignName;
